// extracted by mini-css-extract-plugin
export default {"component":"error-feature-toggle_component__Fa46o","content-fade":"error-feature-toggle_content-fade__tGpah"};